import { Label } from '~shared/shadcn/ui/label';
import { Switch } from '~shared/shadcn/ui/switch';

interface EventDateSelectionSwitchProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

export const EventDateSelectionSwitch = ({
  checked,
  onCheckedChange,
}: EventDateSelectionSwitchProps) => (
  <div className='flex items-start gap-3 rounded-md border p-3'>
    <Switch
      id='allow-specific-dates-selection'
      checked={checked}
      onCheckedChange={onCheckedChange}
    />
    <div className='space-y-1'>
      <Label htmlFor='allow-specific-dates-selection'>
        Allow specific date selection
      </Label>
      <p className='text-sm text-muted-foreground'>
        Parents can choose the event dates they plan to attend during enrollment.
      </p>
    </div>
  </div>
);
